import axios from 'axios'

const state = () => ({
  usefulLink: []
})

const getters = {
  usefulLink(state) {
    return state.usefulLink
  }
}

const mutations = {
  SET_USEFULLINK(state, payload){
    state.usefulLink = payload
  },

}

const actions = {
  getUsefulLink({commit}){
    axios.get('https://api.geomalaka.uz/api/main/foydali-havolalar/')
    .then((res)=>{
      commit("SET_USEFULLINK", res.data)
    })
    .catch((error)=>{console.log})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

